import React from "react";

export default function RenderInfo({
  Stat,

  technique,
  model,
  textureName,

  tam,

  toon,
  gooch,
  halftone,
  outline,
  pbr,
}) {
  const styleName =
    technique === "hatching"
      ? "TAM"
      : technique === "toon"
        ? "TOON"
        : technique === "gooch"
          ? "GOOCH"
          : technique === "halftone"
            ? "HALFTONE"
            : technique === "outline"
              ? "OUTLINE"
              : "PBR";

  return (
    <>
      <Stat label="Style" value={styleName} />

      <Stat label="Model" value={model.name} />

      <Stat label="Texture" value={textureName} />

      <Stat label="Passes" value="1" />

      {technique === "hatching" && (
        <>
          <Stat label="Tones" value={tam.tones.length.toString()} />

          <Stat label="Levels" value={tam.levels.toString()} />
        </>
      )}

      {technique === "toon" && (
        <Stat label="Bands" value={toon.bands.toString()} />
      )}

      {technique === "gooch" && (
        <>
          <Stat label="Cool Mix" value={gooch.coolMix.toFixed(2)} />

          <Stat label="Warm Mix" value={gooch.warmMix.toFixed(2)} />
        </>
      )}

      {technique === "halftone" && (
        <>
          <Stat label="Dot Size" value={halftone.dotSize.toFixed(1)} />

          <Stat label="Angle" value={`${halftone.angle.toFixed(0)}°`} />
        </>
      )}

      {technique === "outline" && (
        <>
          <Stat label="Silhouette" value={outline.silhouetteWidth.toFixed(2)} />

          <Stat label="Detail" value={outline.detailStrength.toFixed(1)} />
        </>
      )}

      {technique === "pbr" && (
        <>
          <Stat label="Metallic" value={pbr.metallic.toFixed(2)} />

          <Stat label="Roughness" value={pbr.roughness.toFixed(2)} />
        </>
      )}
    </>
  );
}
